import React, {FC} from "react";
import {Moment} from "moment";
import {EuiDatePicker, EuiDatePickerRange} from "@elastic/eui";

export interface IDateRangePicker {
    startDate: Moment
    endDate: Moment
    onChange: (startDate: Moment, endDate: Moment) => void
    maxDate?: Moment
    minDate?: Moment
}

export const DateRangePicker: FC<IDateRangePicker> = props => {

    const onStartDateChange = (date: Moment) => {
        props.onChange(date, props.endDate)
    }

    const onEndDateChange = (date: Moment) => {
        props.onChange(props.startDate, date)
    }

    return (
        <EuiDatePickerRange
            startDateControl={
                <EuiDatePicker
                    selected={props.startDate}
                    maxDate={props.maxDate}
                    minDate={props.minDate}
                    onChange={(date) => date && onStartDateChange(date)}
                    startDate={props.startDate}
                    endDate={props.endDate}
                    aria-label="Start date"
                />
            }
            endDateControl={
                <EuiDatePicker
                    selected={props.endDate}
                    maxDate={props.maxDate}
                    minDate={props.minDate}
                    onChange={(date) => date && onEndDateChange(date)}
                    startDate={props.startDate}
                    endDate={props.endDate}
                    aria-label="End date"
                />
            }
        />
    )
}